import { Injectable } from "@angular/core";

import { dateToDb, dbToDate, dbToFloat, dbToInt, floatToDb, intToDb, stringToDb } from "@dffedb/util";

import { InstallationMaalerAflaesningDto } from "./model/installation-maaler-aflaesning.dto";
import { InstallationMaalerAflaesning } from "./model/installation-maaler-aflaesning.model";

@Injectable({ providedIn: "root" })
export class InstallationMaalerAflaesningMapper {
    public dtoToInstallationMaalerAflaesning(dto: InstallationMaalerAflaesningDto): InstallationMaalerAflaesning {
        const result: InstallationMaalerAflaesning = {
            ejendomNr: dbToInt(dto.ejendomnr),
            installationNr: dbToInt(dto.i_nr),
            aktivNr: dbToInt(dto.aktivnr),
            dato: dbToDate(dto.dato),
            aflaesning: {
                maalerNr: { oprindelig: dto.maalerNr, aktuel: dto.maalerNr },
                maalerTypeId: { oprindelig: dto.maalerTypeId, aktuel: dto.maalerTypeId },
                taellevaerker: dto.taellevaerker.map((t) => ({
                    historiskAflaesning: dbToFloat(t.enhedvaerdi),
                    enhedType: t.enhedtype,
                    aflaesning: { oprindelig: null, aktuel: null }
                }))
            }
        };
        return result;
    }

    public installationMaalerAflaesningToDto(model: InstallationMaalerAflaesning): InstallationMaalerAflaesningDto {
        const result: InstallationMaalerAflaesningDto = {
            ejendomnr: intToDb(model.ejendomNr),
            aktivnr: intToDb(model.aktivNr),
            // eslint-disable-next-line @typescript-eslint/naming-convention
            i_nr: intToDb(model.installationNr),
            dato: dateToDb(model.dato),
            maalerTypeId: intToDb(model.aflaesning.maalerTypeId.aktuel),
            maalerNr: stringToDb(model.aflaesning.maalerNr.aktuel),
            taellevaerker: model.aflaesning.taellevaerker.map((tv) => ({
                enhedvaerdi: floatToDb(tv.historiskAflaesning),
                enhed: floatToDb(tv.aflaesning.aktuel),
                enhedtype: stringToDb(tv.enhedType)
            }))
        };
        return result;
    }
}
